import { Typography } from '@mui/material'

/**
 * Compact circular color picker — a small color circle that opens the native colour
 * picker on click (replaces the wide, unfriendly `<input type="color">` strips).
 */
function normalizeColor(value, fallback) {
  return /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(value || '') ? value : fallback
}

export default function ColorSwatchInput({
  label,
  value,
  onChange,
  disabled = false,
  fallback = '#000000',
  size = 24,
}) {
  const color = normalizeColor(value, fallback)
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
      <label
        title={label}
        style={{
          position: 'relative',
          width: size,
          height: size,
          borderRadius: '50%',
          background: color,
          border: '1px solid rgba(15,23,42,0.18)',
          boxShadow: 'inset 0 0 0 2px #fff',
          cursor: disabled ? 'default' : 'pointer',
          flexShrink: 0,
          display: 'inline-block',
        }}
      >
        <input
          type="color"
          value={color}
          onChange={onChange}
          disabled={disabled}
          aria-label={label}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            opacity: 0,
            border: 0,
            padding: 0,
            margin: 0,
            cursor: 'inherit',
          }}
        />
      </label>
      {label && (
        <Typography variant="body2" sx={{ minWidth: 0 }}>
          {label}
        </Typography>
      )}
    </div>
  )
}
